import { FC, useState } from 'react'
import { MaintainerModal } from '@/presentation/common/components/maintainer/MaintainerModal.tsx'
import { SidebarButton } from '@/presentation/common/components/SidebarButton.tsx'
import { useCrudAuth } from '@/presentation/common/hooks/crud/useCrudAuth.ts'
import { useActionsModal } from '@/presentation/common/hooks/useActionsModal.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { CreateMachineryForm } from '@/presentation/machinery/forms/CreateMachineryForm.tsx'
import { DeleteMachineryForm } from '@/presentation/machinery/forms/DeleteMachineryForm.tsx'
import { MachineryActionsProps } from '@/presentation/machinery/forms/types.ts'
import { UpdateMachineryForm } from '@/presentation/machinery/forms/UpdateMachineryForm.tsx'

export const MachineryActions: FC<MachineryActionsProps> = ({ onAction }) => {
  const selectionCount = useMaintainerStore((state) => state.selectionCountV2())

  const { canCreate, canUpdate, canDelete } = useCrudAuth()
  const { open, setOpen } = useActionsModal()
  const [ option, setOption ] = useState<'POST' | 'PUT' | 'DELETE' | null>(null)

  const isPost = option === 'POST'
  const isPut = option === 'PUT'
  const isDelete = option === 'DELETE'

  const title = isPost ? 'Registrar maquinaria' : isPut ? 'Actualizar maquinaria' : 'Eliminar selección'

  const closeModal = () => {
    setOpen(false)
    setOption(null)
  }

  const onFinish = () => {
    closeModal()
    onAction?.()
  }

  return (
    <>
      <MaintainerModal title={title} open={open}>
        {isPost && <CreateMachineryForm onCancel={closeModal} onFinish={onFinish}/>}
        {isPut && <UpdateMachineryForm onCancel={closeModal} onFinish={onFinish}/>}
        {isDelete && <DeleteMachineryForm onCancel={closeModal} onFinish={onFinish}/>}
      </MaintainerModal>

      {canCreate && (
        <SidebarButton label="Registrar maquinaria" type="POST" onClick={() => {
          setOption('POST')
          setOpen(true)
        }}/>
      )}

      {canUpdate && (
        <SidebarButton label="Actualizar maquinaria" type="PUT" onClick={() => {
          setOption('PUT')
          setOpen(true)
        }}/>
      )}

      {canDelete && (
        <SidebarButton label={`Eliminar selección (${selectionCount})`} type="DELETE" onClick={() => {
          setOption('DELETE')
          setOpen(true)
        }}/>
      )}
    </>
  )
}
